// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__pSjUh","file":"styles_file__D6Ew4"};